module.exports = __webpack_public_path__ + "img/title.ac55a42f.jpg";